import {
  SiPython, SiSalesforce, SiGit, SiJira, SiNotion, SiConfluence,
  SiMysql, SiPostgresql, SiMongodb, SiOpenai, SiGithubcopilot,
  SiAnthropic, SiGoogleads,
} from 'react-icons/si';
import { TbSql, TbBrain, TbDatabase, TbApi } from 'react-icons/tb';
import { FaAws } from 'react-icons/fa';
import { VscCode, VscAzureDevops } from 'react-icons/vsc';

export const SKILL_ICONS = {
  'Python':           SiPython,
  'SQL':              TbSql,
  'LLMs':             TbBrain,
  'Azure DevOps':     VscAzureDevops,
  'Salesforce':       SiSalesforce,
  'Oracle':           TbDatabase,
  'Ads Manager':      SiGoogleads,
  'AWS':              FaAws,
  'Git':              SiGit,
  'Jira':             SiJira,
  'Notion':           SiNotion,
  'Confluence':       SiConfluence,
  'MySQL':            SiMysql,
  'Postgres':         SiPostgresql,
  'MongoDB':          SiMongodb,
  'API Integration':  TbApi,
  'Claude Code':      SiAnthropic,
  'Codex':            SiOpenai,
  'GitHub Copilot':   SiGithubcopilot,
  'VS Code':          VscCode,
};
